import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { TextCallout1, TextCallout2, Button, colors } from '@blocket/blocket-ui'
import PropTypes from 'prop-types'
import { mediaQueries } from 'plugins/device'

const ChannelPromptWrapper = styled.div`
  padding: 16px;
  border-top: 1px solid ${colors.grey200};

  @media ${mediaQueries.medium} {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
  }
`

const InfoHeader = styled(TextCallout1)`
  margin-bottom: 4px;
`

const ChannelPromptButton = styled(Button)`
  max-height: 30px;
  display: inline-block;
  width: auto;
  margin-top: 8px;
  @media ${mediaQueries.large} {
    margin-top: 0px;
  }
`
export const BLOCKED_USER_CONTENT = {
  header: 'Du har blockerat användaren',
  text: 'Ni kan inte skicka meddelanden till varandra.',
  btnText: 'Avblockera användare',
}

export const USERS_OWN_AD_HEADER = 'Du kan inte svara på din egen annons'

const PromptTypes = { BlockedUser: 'blocked_user', UsersOwnAd: 'users_own_ad' }

const ChannelPrompt = ({ onClick, promptType }) => {
  const [content, setContent] = useState({
    header: '',
    text: '',
    btnText: '',
    btnOnClick: () => {},
  })

  useEffect(() => {
    switch (promptType) {
      case PromptTypes.BlockedUser:
        return setContent({
          header: BLOCKED_USER_CONTENT.header,
          text: BLOCKED_USER_CONTENT.text,
          btnText: BLOCKED_USER_CONTENT.btnText,
          btnOnClick: onClick,
        })
      case PromptTypes.UsersOwnAd:
        return setContent({
          header: USERS_OWN_AD_HEADER,
        })
      default:
        break
    }
  }, [onClick, promptType])

  return (
    <ChannelPromptWrapper>
      <div>
        <InfoHeader>{content.header}</InfoHeader>
        {content.text && <TextCallout2>{content.text}</TextCallout2>}
      </div>
      {content.btnText && (
        <ChannelPromptButton size="tiny" onClick={content.btnOnClick}>
          {content.btnText}
        </ChannelPromptButton>
      )}
    </ChannelPromptWrapper>
  )
}

ChannelPrompt.propTypes = {
  promptType: PropTypes.oneOf(Object.values(PromptTypes)),
  onClick: PropTypes.func,
}

export default ChannelPrompt
